import { PHOTO_COMMENT_FORM } from "../constants"

export default class FormCommentElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @returns {FormCommentElement?}
   * @memberof FormCommentElement
   */
  static fromHtmlElement(htmlElement) {
    const element = htmlElement.querySelector(PHOTO_COMMENT_FORM)

    if (element == null) {
      return null
    }

    return new FormCommentElement(htmlElement.querySelector(PHOTO_COMMENT_FORM))
  }

  /**
   * Creates an instance of FormCommentElement.
   * @param {HTMLFormElement} element
   * @memberof FormCommentElement
   */
  constructor(element) {
    this.element = element

    this.element.querySelector("#jscheck").value = "ok"
  }

  /**
   * @param {import('../models/photo-entity').default} photo
   * @memberof FormCommentElement
   */
  apply(photo) {
    this.element.action = this.element.action.replace(/\d+/, photo.id)
  }
}
